export interface ArticleDetail {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  categoryName: string;
  coverImage: string;
  coverImageWidth: number;
  coverImageHeight: number;
  author: string;
  date: string;
  views: number;
  comments: number;
  shares: number;
  tags: string[];
  content: ArticleContentBlock[];
  relatedArticles: {
    id: string;
    title: string;
    image: string;
    categoryName: string;
    date: string;
    views: number;
  }[];
}

export interface ArticleContentBlock {
  type: 'paragraph' | 'heading' | 'image' | 'quote' | 'list';
  content?: string;
  imageUrl?: string;
  imageWidth?: number;
  imageHeight?: number;
  imageAlt?: string;
  items?: string[];
}

export const articleDetailMap: Record<string, ArticleDetail> = {
  'article-001': {
    id: 'article-001',
    title: '某千万粉丝网红直播翻车现场全记录：人设崩塌仅用三分钟',
    subtitle: '一场普通直播如何让顶流网红从神坛跌落？全程实录与深度分析',
    category: 'wanghong',
    categoryName: '网红翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=Breaking%20news%20dramatic%20moment%20on%20livestream%20screen%20with%20shocked%20expression%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20social%20media%20controversy%20concept%2C%20editorial%20style%20with%20bold%20contrast%2C%20cinematic%20composition%2C%20intense%20mood&width=1200&height=675&seq=article-cov-001&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜前线记者',
    date: '2026-07-07',
    views: 1258000,
    comments: 36200,
    shares: 89500,
    tags: ['网红翻车', '直播事故', '人设崩塌', '带货翻车'],
    content: [
      {
        type: 'paragraph',
        content: '7月7日晚间，一场原本计划中的普通带货直播，却成为了2026年迄今为止最大的网红翻车事件。拥有三千万粉丝的顶流主播"小甜甜"（化名），在直播过程中因一个不经意的口误，在短短三分钟内从网红神坛跌落，引发了全网范围内的巨大争议。',
      },
      {
        type: 'paragraph',
        content: '据现场观众录屏显示，当晚8点30分左右，"小甜甜"正在推销一款标价299元的国产品牌护肤品。在介绍产品成分时，她声称该产品"采用瑞士进口高端原料，由法国顶级实验室研发"，并在直播间信誓旦旦地保证："我用这款产品已经三年了，皮肤才变得这么好。"',
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20livestream%20shopping%20interface%20with%20beauty%20product%2C%20dramatic%20warm%20lighting%2C%20closeup%20detail%20shot%2C%20editorial%20photography%20style%2C%20dark%20background&width=800&height=500&seq=article-img-001a&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '直播带货现场截图',
      },
      {
        type: 'heading',
        content: '致命口误：三分钟崩塌全过程',
      },
      {
        type: 'paragraph',
        content: '然而，就在这时，一位自称在该品牌代工厂工作的网友在弹幕中揭露："这个产品明明是在广州白云区生产的，原料都是国产的，哪来的瑞士进口？"这条弹幕迅速引发关注，直播间的氛围瞬间变得微妙起来。',
      },
      {
        type: 'paragraph',
        content: '面对质疑，"小甜甜"明显慌了神。她先是试图忽略弹幕，继续念准备好的台词，但在越来越多的质疑声中，她脱口而出了一句彻底断送自己网红生涯的话："你们这些人懂什么？我一场直播赚的钱你们一辈子都赚不到，有什么资格质疑我？"',
      },
      {
        type: 'quote',
        content: '"你们这些人懂什么？我一场直播赚的钱你们一辈子都赚不到，有什么资格质疑我？"——这句傲慢的回应，成为了她网红生涯的转折点。',
      },
      {
        type: 'paragraph',
        content: '这句话一说出口，直播间的弹幕瞬间炸锅。原本还在观望的粉丝纷纷倒戈，愤怒的观众开始在各大社交平台转发录屏片段。不到十分钟，话题"小甜甜直播翻车"就冲上了微博热搜第一，阅读量在半小时内突破3亿。',
      },
      {
        type: 'heading',
        content: '连锁反应：品牌方紧急解约',
      },
      {
        type: 'paragraph',
        content: '事件发酵后，与该网红合作的多个品牌方迅速作出反应。截至当晚11点，已有至少8个品牌通过官方账号发布声明，宣布终止与"小甜甜"的所有合作关系。其中，某国际知名美妆品牌在声明中表示："我们始终坚持诚信经营的原则，对于合作方的任何不当言论和行为保持零容忍态度。"',
      },
      {
        type: 'list',
        items: [
          '当晚11:00——首个品牌方发布解约声明',
          '次日凌晨1:00——累计8个品牌宣布解约',
          '次日上午9:00——平台方宣布对该账号进行30天封禁处理',
          '次日下午2:00——该网红发布道歉视频，但被指态度敷衍',
          '次日晚上8:00——消费者协会宣布介入调查',
          '第三日上午——市场监管部门正式立案调查虚假宣传问题',
        ],
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Multiple%20brand%20logos%20on%20dark%20background%20with%20cancellation%20stamp%20marks%2C%20dramatic%20red%20and%20dark%20lighting%2C%20business%20contract%20termination%20concept%2C%20editorial%20style&width=800&height=500&seq=article-img-001b&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '品牌方纷纷解约示意图',
      },
      {
        type: 'heading',
        content: '深度分析：网红经济的信任危机',
      },
      {
        type: 'paragraph',
        content: '此次事件绝非个案，它折射出当下网红经济存在的深层次问题。近年来，从虚假宣传到偷税漏税，从人设崩塌到产品质量问题，网红翻车事件层出不穷。每一次翻车背后，都是消费者信任的严重透支。',
      },
      {
        type: 'paragraph',
        content: '业内人士分析指出，当前的网红带货模式存在几个核心问题：一是选品把关不严，许多网红为了追求高佣金，对所推荐产品的质量缺乏基本审核；二是虚假宣传普遍，很多网红的"亲测推荐"实际上从未使用过产品；三是缺乏有效的监管和惩罚机制，导致违规成本过低。',
      },
      {
        type: 'paragraph',
        content: '据本网了解，"小甜甜"此次推荐的护肤品，实际出厂价仅为15元/瓶，而其在直播间的售价高达299元，溢价接近20倍。更令人震惊的是，这款产品此前已多次被消费者投诉存在过敏、无效等问题，但"小甜甜"的团队显然对此视而不见。',
      },
      {
        type: 'heading',
        content: '后续影响：行业整顿呼之欲出',
      },
      {
        type: 'paragraph',
        content: '此次事件可能成为网红直播行业的一个重要转折点。多位法律专家表示，网红在直播中对产品的虚假宣传已经涉嫌违反《广告法》和《消费者权益保护法》，情节严重的可能构成虚假广告罪。市场监管部门对此类行为的打击力度预计将进一步加大。',
      },
      {
        type: 'paragraph',
        content: '而对于广大吃瓜群众来说，这无疑又是一次深刻的教训：不要轻信网红的"亲身推荐"，理性消费才是正道。正如一位网友在评论区所说："花299买一瓶15块钱的面霜，这就是交的智商税。"',
      },
      {
        type: 'paragraph',
        content: '截至发稿时，"小甜甜"的社交账号粉丝数已从3000万暴跌至不足800万，多个商业合作已被终止，其经纪公司也宣布与其解除合约。据悉，她还将面临多个品牌方的违约索赔，索赔总额可能超过5000万元。',
      },
      {
        type: 'paragraph',
        content: '吃瓜官网将持续关注此事件的后续进展，为您带来第一手的独家报道。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-003',
        title: '某知名带货主播涉嫌虚假宣传被立案调查，粉丝群炸锅了',
        image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20dark%20moody%20lighting%2C%20scandal%20and%20controversy%20theme%2C%20dramatic%20atmosphere%2C%20news%20breaking%20story&width=400&height=300&seq=related-a-001&orientation=landscape',
        categoryName: '热门爆料',
        date: '2026-07-06',
        views: 1890000,
      },
      {
        id: 'article-008',
        title: '网曝某综艺节目恶意剪辑制造矛盾，选手原话被严重扭曲',
        image: 'https://readdy.ai/api/search-image?query=TV%20show%20editing%20room%20with%20dramatic%20red%20and%20dark%20lighting%2C%20manipulation%20concept&width=400&height=300&seq=related-a-002&orientation=landscape',
        categoryName: '网红翻车',
        date: '2026-07-04',
        views: 892000,
      },
      {
        id: 'article-005',
        title: '深扒某MCN机构内幕：签约网红被严苛合同压榨，违约金高达千万',
        image: 'https://readdy.ai/api/search-image?query=Dark%20business%20contract%20with%20chain%20symbolism%2C%20dramatic%20lighting%2C%20corporate%20exploitation%20concept&width=400&height=300&seq=related-a-003&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-05',
        views: 1560000,
      },
    ],
  },
  'article-002': {
    id: 'article-002',
    title: '独家爆料：某顶流明星深夜密会神秘女子，酒店同框照曝光',
    subtitle: '独家获得照片显示顶流男星深夜密会，工作室至今未回应',
    category: 'celeb',
    categoryName: '明星大瓜',
    coverImage: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20of%20a%20figure%20entering%20luxury%20hotel%2C%20blurry%20candid%20shot%2C%20dramatic%20warm%20street%20lighting%20at%20night%2C%20mysterious%20atmosphere%2C%20celebrity%20gossip%20concept&width=1200&height=675&seq=article-cov-002&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜特派员',
    date: '2026-07-06',
    views: 2380000,
    comments: 52100,
    shares: 120000,
    tags: ['明星大瓜', '独家爆料', '顶流塌房'],
    content: [
      {
        type: 'paragraph',
        content: '7月6日凌晨，本网独家获得一组照片，显示某当红顶流男星（化名L先生）深夜与一名神秘女子在某五星级酒店同框。这组照片拍摄于7月5日晚间11点左右，两人先后进入酒店，举止亲密，引发广泛关注。',
      },
      {
        type: 'paragraph',
        content: '据目击者透露，该男星当晚身着黑色休闲装、戴着口罩和帽子低调出现在酒店大堂，而该神秘女子则身穿一条淡粉色连衣裙，大约在男星到达后二十分钟进入同一酒店。',
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20lobby%20at%20night%20with%20dramatic%20warm%20lighting%2C%20mysterious%20figure%20silhouette%2C%20luxury%20atmosphere%2C%20paparazzi%20style%20photography%2C%20editorial%20composition&width=800&height=500&seq=article-img-002a&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '酒店现场照片',
      },
      {
        type: 'heading',
        content: '照片细节分析',
      },
      {
        type: 'paragraph',
        content: '本网请到了多位影像鉴定专家对照片进行了分析。专家一致认为，照片中的人物特征与该男星的体型、走路姿态高度吻合。照片的时间戳和地理位置信息也与当天的行程高度匹配。',
      },
      {
        type: 'paragraph',
        content: '更值得注意的是，该男星在第二天早上7点左右独自离开酒店，而神秘女子则在上午9点才从酒店出来。两人刻意错开离开时间的行为，更加引发了外界的猜测。',
      },
      {
        type: 'quote',
        content: '"作为一个公众人物，他应该对自己的行为负责。如果真的有了新的感情，应该坦诚面对，而不是这样偷偷摸摸的。"——某圈内人士匿名评论',
      },
      {
        type: 'heading',
        content: '粉丝反应两极分化',
      },
      {
        type: 'paragraph',
        content: '消息传出后，该男星的粉丝群出现了明显的分裂。一部分忠实粉丝坚称这只是普通的社交活动，"明星也是人，有正常的社交生活很正常"。但另一部分粉丝则表示失望和愤怒，认为偶像欺骗了他们的感情。',
      },
      {
        type: 'paragraph',
        content: '截至目前，该男星的工作室仍未对此事作出任何回应。其个人社交账号最近一条动态停留在三天前，评论区已经被相关质疑刷屏。',
      },
      {
        type: 'paragraph',
        content: '吃瓜官网将持续关注此事件的最新进展。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-004',
        title: '某选秀节目冠军被爆学历造假，母校澄清声明引更大争议',
        image: 'https://readdy.ai/api/search-image?query=Graduation%20diploma%20under%20investigation%20with%20magnifying%20glass%2C%20dramatic%20shadow%20lighting%2C%20academic%20scandal%20concept&width=400&height=300&seq=related-b-001&orientation=landscape',
        categoryName: '明星大瓜',
        date: '2026-07-06',
        views: 985000,
      },
      {
        id: 'article-009',
        title: '独家：某知名歌手税务问题再起波澜，补缴金额惊人',
        image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20tax%20investigation%20concept&width=400&height=300&seq=related-b-002&orientation=landscape',
        categoryName: '明星大瓜',
        date: '2026-07-03',
        views: 3210000,
      },
      {
        id: 'article-006',
        title: '网传某知名导演婚内出轨女演员，知情人士透露更多细节',
        image: 'https://readdy.ai/api/search-image?query=Film%20director%20silhouette%20with%20actress%20shadow%20on%20movie%20set%2C%20dramatic%20backlighting&width=400&height=300&seq=related-b-003&orientation=landscape',
        categoryName: '热门爆料',
        date: '2026-07-05',
        views: 2100000,
      },
    ],
  },
  'article-003': {
    id: 'article-003',
    title: '某知名带货主播涉嫌虚假宣传被立案调查，粉丝群炸锅了',
    subtitle: '直播间推荐的进口高端护肤品被证实为三无产品',
    category: 'hot',
    categoryName: '热门爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20dark%20moody%20lighting%2C%20scandal%20and%20controversy%20theme%2C%20dramatic%20atmosphere%2C%20news%20breaking%20story%2C%20forensic%20style%20lighting&width=1200&height=675&seq=article-cov-003&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜调查组',
    date: '2026-07-06',
    views: 1890000,
    comments: 44500,
    shares: 98000,
    tags: ['带货翻车', '虚假宣传', '立案调查'],
    content: [
      {
        type: 'paragraph',
        content: '据可靠消息，某头部带货主播因涉嫌虚假宣传已被市场监管部门正式立案调查。该主播在直播间推荐的所谓"法国进口高端护肤品"被证实为国内小作坊生产的三无产品。',
      },
      {
        type: 'paragraph',
        content: '本网记者实地走访了该产品的"生产基地"——一个位于市郊的简陋厂房。现场环境令人震惊：没有无菌车间，没有质检设备，甚至没有一个合格的操作人员。',
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20abandoned%20factory%20interior%20with%20dramatic%20lighting%2C%20rundown%20production%20line%2C%20moody%20atmosphere%2C%20investigative%20documentary%20style%2C%20warm%20amber%20highlights&width=800&height=500&seq=article-img-003a&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '生产基地现场照片',
      },
      {
        type: 'heading',
        content: '消费者集体维权',
      },
      {
        type: 'paragraph',
        content: '事件曝光后，购买了该产品的消费者在社交平台组织了维权群。据不完全统计，截至发稿时，已有超过2000名消费者加入了维权行动，涉及的货款金额超过500万元。',
      },
      {
        type: 'paragraph',
        content: '多名消费者反映，使用该产品后出现了不同程度的皮肤过敏症状。其中一位女性消费者表示："买的时候看主播说得多好多好，结果用了不到一周脸就开始红肿发痒，去皮肤科看了才知道是产品过敏。"',
      },
      {
        type: 'quote',
        content: '"我用了之后整张脸都烂了！这个主播必须负法律责任！"——某消费者在社交平台的控诉',
      },
      {
        type: 'heading',
        content: '平台回应与后续',
      },
      {
        type: 'paragraph',
        content: '直播平台方面表示，已对该主播账号进行了临时封禁处理，并配合监管部门展开调查。平台承诺将先行垫付消费者的退款。',
      },
      {
        type: 'paragraph',
        content: '法律专家指出，该主播的行为已经涉嫌触犯《刑法》中的"生产、销售伪劣产品罪"和《广告法》中的"虚假广告"条款，可能面临刑事责任。',
      },
      {
        type: 'paragraph',
        content: '吃瓜官网提醒广大消费者：购买网红推荐产品时请保持理性，认清产品资质和来源，切勿盲目跟风。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-001',
        title: '某千万粉丝网红直播翻车现场全记录：人设崩塌仅用三分钟',
        image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20dramatic%20moment%20on%20livestream%20screen%20with%20shocked%20expression&width=400&height=300&seq=related-c-001&orientation=landscape',
        categoryName: '网红翻车',
        date: '2026-07-07',
        views: 1258000,
      },
      {
        id: 'article-011',
        title: '扒一扒某网红餐厅背后的灰色产业链，食材来源触目惊心',
        image: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dramatic%20shadow%20lighting%2C%20food%20safety%20scandal%20concept&width=400&height=300&seq=related-c-002&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-02',
        views: 678000,
      },
    ],
  },
  'article-004': {
    id: 'article-004',
    title: '某选秀节目冠军被爆学历造假，母校澄清声明引更大争议',
    subtitle: '冠军自称名校硕士身份存疑，学校回应仅短期培训学员',
    category: 'celeb',
    categoryName: '明星大瓜',
    coverImage: 'https://readdy.ai/api/search-image?query=Graduation%20diploma%20under%20investigation%20with%20magnifying%20glass%2C%20dramatic%20shadow%20lighting%2C%20academic%20scandal%20concept%2C%20mysterious%20dark%20mood&width=1200&height=675&seq=article-cov-004&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜编辑组',
    date: '2026-07-06',
    views: 985000,
    comments: 28900,
    shares: 56700,
    tags: ['学历造假', '选秀冠军', '明星翻车'],
    content: [
      {
        type: 'paragraph',
        content: '近期火爆的选秀节目总冠军被网友扒出学历造假，其自称的"某985高校硕士"身份存疑。经本网记者核实，学校官方回应称：该选手仅为短期培训项目学员，并非正式注册的硕博研究生。',
      },
      {
        type: 'paragraph',
        content: '这一回应非但没有平息争议，反而引发了更大的舆论风波。网友们纷纷质疑：为什么节目组在选手参赛时没有进行背景审核？',
      },
      {
        type: 'heading',
        content: '事件来龙去脉',
      },
      {
        type: 'paragraph',
        content: '在选秀节目播出期间，该选手一直在节目中强调自己的"名校研究生"身份，甚至在一次采访中声称自己"为了学业放弃了多个演艺机会"。这番言论为其赢得了不少好感度。',
      },
      {
        type: 'paragraph',
        content: '然而，一位自称是该学校校友的网友在论坛上发帖称，在学校的研究生招生系统中无法查到该选手的任何信息。随后，更多的证据被陆续曝光。',
      },
      {
        type: 'paragraph',
        content: '本网将继续关注事件进展，还原事实真相。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-002',
        title: '独家爆料：某顶流明星深夜密会神秘女子，酒店同框照曝光',
        image: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20figure%20entering%20luxury%20hotel%2C%20dramatic%20warm%20street%20lighting&width=400&height=300&seq=related-d-001&orientation=landscape',
        categoryName: '明星大瓜',
        date: '2026-07-06',
        views: 2380000,
      },
    ],
  },
  'article-005': {
    id: 'article-005',
    title: '深扒某MCN机构内幕：签约网红被严苛合同压榨，违约金高达千万',
    subtitle: '多位匿名网红爆料MCN霸王条款，解约需赔偿千万',
    category: 'black-material',
    categoryName: '黑料专区',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20business%20contract%20with%20chain%20symbolism%2C%20dramatic%20lighting%20from%20side%2C%20corporate%20exploitation%20concept%2C%20moody%20atmosphere&width=1200&height=675&seq=article-cov-005&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜调查组',
    date: '2026-07-05',
    views: 1560000,
    comments: 38700,
    shares: 72300,
    tags: ['MCN内幕', '霸王合同', '网红维权'],
    content: [
      {
        type: 'paragraph',
        content: '多位不愿意透露姓名的签约网红向本网爆料，某知名MCN机构存在严重的霸王条款问题。签约主播不仅分成比例极低（最低仅5%），一旦提出解约，还需面临最高达千万级别的天价违约金。',
      },
      {
        type: 'heading',
        content: '触目惊心的合同条款',
      },
      {
        type: 'paragraph',
        content: '根据爆料人提供的合同片段，该MCN机构的合同存在多项不合理条款：签约期限长达10年、主播需全权交出账号所有权、所有内容创作需经公司审批、解约需支付"培训费"等巨额赔偿。',
      },
      {
        type: 'list',
        items: [
          '合同期限：10年起，可自动续约',
          '分成比例：主播仅5%-15%',
          '账号归属：全部归公司所有',
          '违约金：按"预期收益"计算，最高可达千万',
          '竞业限制：解约后3年内不得从事相关行业',
        ],
      },
      {
        type: 'paragraph',
        content: '法律专家指出，部分条款明显违反《劳动合同法》和《民法典》的相关规定，可能被认定为无效。本网将持续关注此事件的后续进展。',
      },
    ],
    relatedArticles: [],
  },
  'article-006': {
    id: 'article-006',
    title: '网传某知名导演婚内出轨女演员，知情人士透露更多细节',
    subtitle: '知名导演被指在剧组与女演员关系暧昧，多方人士证实',
    category: 'hot',
    categoryName: '热门爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20silhouette%20with%20actress%20shadow%20on%20movie%20set%2C%20dramatic%20backlighting%2C%20scandal%20concept%2C%20moody%20cinematic%20lighting&width=1200&height=675&seq=article-cov-006&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜编辑组',
    date: '2026-07-05',
    views: 2100000,
    comments: 63500,
    shares: 130000,
    tags: ['导演出轨', '娱乐圈丑闻', '婚内出轨'],
    content: [
      {
        type: 'paragraph',
        content: '近日，一则关于某知名已婚导演与剧组女演员关系暧昧的传闻在娱乐圈广泛流传。多位知情人士向本网证实，两人在拍摄期间确实存在超越正常合作关系的行为。',
      },
      {
        type: 'paragraph',
        content: '据剧组工作人员透露，该导演在片场对该女演员格外照顾，不仅多次为其加戏，还经常以"讨论剧本"为由进行长时间的一对一交流。两人在拍摄期间还多次被目击私下共进晚餐。',
      },
      {
        type: 'paragraph',
        content: '目前，该导演的妻子在社交平台上的动态引发了粉丝的担忧。她最新的一条动态写着"有些事，终究是要面对的"，似乎暗示已经知道了什么。',
      },
      {
        type: 'paragraph',
        content: '本网尝试联系该导演及其工作室，但截至目前未获回应。相关消息仍在持续发酵中。',
      },
    ],
    relatedArticles: [],
  },
  'article-007': {
    id: 'article-007',
    title: '某上市公司CEO被爆私生活混乱，多名女性联合实名举报',
    subtitle: '五名女性联合举报互联网上市公司CEO，涉及内容令人震惊',
    category: 'black-material',
    categoryName: '黑料专区',
    coverImage: 'https://readdy.ai/api/search-image?query=Corporate%20executive%20silhouette%20behind%20frosted%20glass%2C%20dramatic%20office%20lighting%2C%20scandal%20investigation%20concept%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%20with%20dark%20amber%20contrast&width=1200&height=675&seq=article-cov-007&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜调查组',
    date: '2026-07-04',
    views: 1730000,
    comments: 51000,
    shares: 95000,
    tags: ['CEO丑闻', '实名举报', '互联网大佬'],
    content: [
      {
        type: 'paragraph',
        content: '一则关于某知名互联网上市公司CEO私生活混乱的爆料近日在社交平台引发轩然大波。据称已有五名女性联合向有关部门实名举报，举报材料中涉及的细节令人震惊。',
      },
      {
        type: 'paragraph',
        content: '该CEO执掌的公司是国内互联网行业的头部企业之一，市值超过千亿。根据举报材料，此人利用职务之便和财富优势，与多名公司女员工及外部女性保持不正当关系，并存在威胁恐吓等恶劣行为。',
      },
      {
        type: 'heading',
        content: '举报材料核心内容',
      },
      {
        type: 'paragraph',
        content: '据知情人士透露，五名举报人提交的材料包括详细的聊天记录、录音、转账凭证以及部分视频证据。这些材料已经提交至公司董事会和相关监管部门，目前正在审查中。',
      },
      {
        type: 'quote',
        content: '"他利用CEO的身份对下属进行精神控制和职场霸凌，不同意他的要求就会被边缘化甚至被迫离职。"——举报材料中的一段描述',
      },
      {
        type: 'heading',
        content: '公司回应与市场反应',
      },
      {
        type: 'paragraph',
        content: '消息传出后，该公司股价在次日开盘后一度暴跌8%。公司紧急发布公告称，已成立独立调查委员会对此事进行全面调查，CEO本人暂未对此事作出公开回应。',
      },
      {
        type: 'paragraph',
        content: '多位公司员工向本网表示，此事在公司内部早已是公开的秘密，但长期以来无人敢于挑战CEO的权威。此次五名女性的勇敢举报，或许将改变这一切。',
      },
      {
        type: 'paragraph',
        content: '本网将持续关注此事件的调查进展，为读者带来最新的独家报道。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-005',
        title: '深扒某MCN机构内幕：签约网红被严苛合同压榨，违约金高达千万',
        image: 'https://readdy.ai/api/search-image?query=Dark%20business%20contract%20with%20chain%20symbolism%2C%20dramatic%20lighting%2C%20corporate%20exploitation%20concept&width=400&height=300&seq=related-g-001&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-05',
        views: 1560000,
      },
      {
        id: 'article-011',
        title: '扒一扒某网红餐厅背后的灰色产业链，食材来源触目惊心',
        image: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dramatic%20shadow%20lighting%2C%20food%20safety%20scandal%20concept&width=400&height=300&seq=related-g-002&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-02',
        views: 678000,
      },
    ],
  },
  'article-008': {
    id: 'article-008',
    title: '网曝某综艺节目恶意剪辑制造矛盾，选手原话被严重扭曲',
    subtitle: '参赛选手晒出原始录音，揭露综艺节目为博取收视率恶意剪辑',
    category: 'wanghong',
    categoryName: '网红翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20show%20editing%20room%20with%20dramatic%20red%20and%20dark%20lighting%2C%20manipulation%20concept%2C%20controversy%20theme%2C%20moody%20editorial%20style%20with%20cinematic%20composition&width=1200&height=675&seq=article-cov-008&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜前线记者',
    date: '2026-07-04',
    views: 892000,
    comments: 32000,
    shares: 58000,
    tags: ['恶意剪辑', '综艺翻车', '造假', '真人秀'],
    content: [
      {
        type: 'paragraph',
        content: '某热门综艺节目的参赛选手近日在社交媒体上晒出了一段原始录音，直指节目组通过恶意剪辑手段制造选手之间的矛盾冲突，以此博取收视率。这段录音与最终播出的节目内容存在惊人的差异。',
      },
      {
        type: 'paragraph',
        content: '该选手在社交平台发文称："我在节目中说的话被剪辑得面目全非。我明明是在夸其他选手，结果播出来变成了我在嘲讽他们。这完全是为了制造矛盾而恶意的剪辑。"',
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Audio%20waveform%20visualization%20with%20dramatic%20red%20and%20dark%20background%2C%20sound%20editing%20concept%2C%20controversy%20theme%2C%20digital%20audio%20workstation%20aesthetic%2C%20moody%20lighting&width=800&height=500&seq=article-img-008a&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '选手提供的原始录音对比图',
      },
      {
        type: 'heading',
        content: '录音与播出内容对比',
      },
      {
        type: 'paragraph',
        content: '本网记者将选手提供的原始录音与节目播出内容进行了详细对比。结果显示，节目组不仅删减了大量上下文，还通过重新排列语句顺序的方式，完全扭曲了选手的原意。原来友好的交流被剪辑成了激烈的争吵，温和的评价被拼接成了尖刻的批评。',
      },
      {
        type: 'list',
        items: [
          '选手原话："我觉得他的表演很有创意，虽然还有一些可以改进的地方" → 播出内容："还有一些可以改进的地方"（删除了正面评价）',
          '选手原话："我真的很佩服XX老师的专业能力，这次合作让我学到了很多" → 播出内容：完全删除，替换为不同场景的冷漠表情',
          '选手原话（被问及对另一选手的看法）："我们关系挺好的，私下经常交流" → 播出内容：拼接成"他这个人挺...（意味深长的停顿）"',
        ],
      },
      {
        type: 'heading',
        content: '行业乱象引发反思',
      },
      {
        type: 'paragraph',
        content: '这一爆料在网络上引发了对综艺节目制作伦理的广泛讨论。多位业内人士匿名向本网透露，恶意剪辑在综艺圈并非个例，许多节目为了提高话题度和收视率，都有专门的"冲突剪辑师"负责制造矛盾场面。',
      },
      {
        type: 'paragraph',
        content: '目前，节目组方面尚未对此事作出正式回应。该选手表示将保留追究法律责任的权力。本网将继续追踪此事进展。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-001',
        title: '某千万粉丝网红直播翻车现场全记录：人设崩塌仅用三分钟',
        image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20dramatic%20moment%20on%20livestream%20screen%20with%20shocked%20expression&width=400&height=300&seq=related-h-001&orientation=landscape',
        categoryName: '网红翻车',
        date: '2026-07-07',
        views: 1258000,
      },
      {
        id: 'article-010',
        title: '某短视频平台大V因不当言论被封号，百万粉丝一夜归零',
        image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20account%20suspended%20notification%2C%20dramatic%20dark%20lighting&width=400&height=300&seq=related-h-002&orientation=landscape',
        categoryName: '社会热点',
        date: '2026-07-03',
        views: 1450000,
      },
    ],
  },
  'article-009': {
    id: 'article-009',
    title: '独家：某知名歌手税务问题再起波澜，补缴金额惊人',
    subtitle: '继上一轮娱乐圈税务风暴后，知名歌手被曝需补缴数亿税款',
    category: 'celeb',
    categoryName: '明星大瓜',
    coverImage: 'https://readdy.ai/api/search-image?query=Financial%20documents%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20tax%20investigation%20concept%2C%20moody%20atmosphere%2C%20business%20scandal%20theme%2C%20editorial%20photography%20with%20warm%20amber%20highlights&width=1200&height=675&seq=article-cov-009&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜特派员',
    date: '2026-07-03',
    views: 3210000,
    comments: 73000,
    shares: 150000,
    tags: ['税务问题', '歌手翻车', '天价补税', '娱乐圈'],
    content: [
      {
        type: 'paragraph',
        content: '继上一轮娱乐圈税务风暴之后，又一位知名歌手被曝出存在严重的税务问题。据可靠消息，该歌手需要补缴的税款及滞纳金高达数亿元，创下了国内娱乐圈个人补税金额的新纪录。',
      },
      {
        type: 'paragraph',
        content: '该歌手在华语乐坛具有极高的知名度，拥有多首传唱度极高的经典作品，商业演出和代言收入同样非常可观。然而，正是这种高收入，为其埋下了税务风险的隐患。',
      },
      {
        type: 'heading',
        content: '税务问题的根源',
      },
      {
        type: 'paragraph',
        content: '据了解，该歌手的税务问题主要集中在以下几个方面：一是通过多层空壳公司将个人收入转换为企业收入，以适用较低的企业所得税税率；二是将大量的个人消费（包括豪宅装修、私人飞机维护等）以"企业经营成本"的名义进行抵扣；三是在境外设立离岸公司，将部分演出收入转移至境外账户。',
      },
      {
        type: 'quote',
        content: '"这些手法的共同特点就是试图将高额的个人收入隐藏起来，逃避个人所得税的高税率。"——某税务律师分析道',
      },
      {
        type: 'heading',
        content: '行业影响与后续发展',
      },
      {
        type: 'paragraph',
        content: '此次事件再次敲响了娱乐圈税务合规的警钟。税务部门表示，将继续加强对高收入人群的税收监管，特别是对娱乐圈、网红直播等新兴行业的税务稽查力度将进一步加强。',
      },
      {
        type: 'paragraph',
        content: '该歌手的工作室已发布声明，承认存在税务申报不完整的情况，并表示正在积极配合税务机关进行整改，补缴相应税款。声明中还强调"所有补缴工作正在有序推进中"。',
      },
      {
        type: 'paragraph',
        content: '然而，对于这份声明，网友们并不买账。有网友评论道："偷税几亿，现在被抓了就说在整改，这剧本看过太多次了。"本网将持续关注此事进展。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-002',
        title: '独家爆料：某顶流明星深夜密会神秘女子，酒店同框照曝光',
        image: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20figure%20entering%20luxury%20hotel&width=400&height=300&seq=related-i-001&orientation=landscape',
        categoryName: '明星大瓜',
        date: '2026-07-06',
        views: 2380000,
      },
      {
        id: 'article-004',
        title: '某选秀节目冠军被爆学历造假，母校澄清声明引更大争议',
        image: 'https://readdy.ai/api/search-image?query=Graduation%20diploma%20under%20investigation%20with%20magnifying%20glass%2C%20dramatic%20shadow%20lighting&width=400&height=300&seq=related-i-002&orientation=landscape',
        categoryName: '明星大瓜',
        date: '2026-07-06',
        views: 985000,
      },
    ],
  },
  'article-010': {
    id: 'article-010',
    title: '某短视频平台大V因不当言论被封号，百万粉丝一夜归零',
    subtitle: '拥有500万粉丝的短视频大V发表不当言论被永久封禁',
    category: 'social',
    categoryName: '社会热点',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20account%20suspended%20notification%2C%20dramatic%20dark%20lighting%2C%20social%20media%20controversy%2C%20moody%20editorial%20style%2C%20warm%20dramatic%20highlights%20on%20dark%20background&width=1200&height=675&seq=article-cov-010&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜编辑组',
    date: '2026-07-03',
    views: 1450000,
    comments: 42000,
    shares: 68000,
    tags: ['账号封禁', '不当言论', '大V翻车', '短视频'],
    content: [
      {
        type: 'paragraph',
        content: '拥有500万粉丝的知名短视频大V"老K说事"（化名）因在直播中发表严重不当言论，其账号被平台方永久封禁。这是近年来短视频平台对头部创作者开出的最严厉罚单之一。',
      },
      {
        type: 'paragraph',
        content: '据了解，该大V在7月2日晚间的直播中，就某社会热点事件发表了极具争议性的言论。直播片段被录屏后在各大平台迅速传播，引发了大量网民的强烈不满和举报。',
      },
      {
        type: 'heading',
        content: '事件时间线',
      },
      {
        type: 'list',
        items: [
          '7月2日 20:00——大V开启日常直播',
          '7月2日 21:15——发表争议性言论',
          '7月2日 21:30——录屏片段开始在社交平台传播',
          '7月2日 22:00——相关话题登上热搜',
          '7月2日 23:30——平台发出临时封禁通知',
          '7月3日 09:00——平台宣布永久封禁决定',
        ],
      },
      {
        type: 'heading',
        content: '过往争议记录',
      },
      {
        type: 'paragraph',
        content: '该大V此前已多次因争议言论被平台警告。在过去两年中，他的账号至少被暂时封禁过三次，但每次解封后他依然我行我素。业内人士分析，他可能错误地认为自己的粉丝量级让他拥有某种"豁免权"。',
      },
      {
        type: 'paragraph',
        content: '然而这一次，平台显然不再容忍。在永久封禁公告中，平台方使用了"严重违反社区规则""造成恶劣社会影响"等措辞，态度前所未有地严厉。',
      },
      {
        type: 'paragraph',
        content: '此次事件也再次提醒所有内容创作者：流量不是护身符，社会责任永远是第一位的。在追求关注度和话题量的同时，切勿触碰法律和道德的底线。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-008',
        title: '网曝某综艺节目恶意剪辑制造矛盾，选手原话被严重扭曲',
        image: 'https://readdy.ai/api/search-image?query=TV%20show%20editing%20room%20with%20dramatic%20red%20and%20dark%20lighting&width=400&height=300&seq=related-j-001&orientation=landscape',
        categoryName: '网红翻车',
        date: '2026-07-04',
        views: 892000,
      },
      {
        id: 'article-003',
        title: '某知名带货主播涉嫌虚假宣传被立案调查，粉丝群炸锅了',
        image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20dark%20moody%20lighting%2C%20scandal%20and%20controversy&width=400&height=300&seq=related-j-002&orientation=landscape',
        categoryName: '热门爆料',
        date: '2026-07-06',
        views: 1890000,
      },
    ],
  },
  'article-011': {
    id: 'article-011',
    title: '扒一扒某网红餐厅背后的灰色产业链，食材来源触目惊心',
    subtitle: '社交平台爆火的网红餐厅被曝后厨乱象，食材安全问题严重',
    category: 'black-material',
    categoryName: '黑料专区',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20with%20dramatic%20shadow%20lighting%2C%20food%20safety%20scandal%20concept%2C%20moody%20atmosphere%2C%20investigative%20journalism%20style%2C%20warm%20and%20dark%20contrast&width=1200&height=675&seq=article-cov-011&orientation=landscape',
    coverImageWidth: 1200,
    coverImageHeight: 675,
    author: '吃瓜调查组',
    date: '2026-07-02',
    views: 678000,
    comments: 21000,
    shares: 35000,
    tags: ['网红餐厅', '灰色产业链', '食品安全', '后厨乱象'],
    content: [
      {
        type: 'paragraph',
        content: '一家在社交平台被追捧为"年度最值得打卡"的网红餐厅，近日被食客曝光后厨存在严重卫生问题。本网记者深入调查后发现，这家餐厅背后隐藏着一条完整的灰色食材供应链，其食材来源和存储条件令人触目惊心。',
      },
      {
        type: 'paragraph',
        content: '这家餐厅主打"高端日式料理"，人均消费在500元以上，在各大美食评测平台上评分一直保持在4.8分以上。然而，光鲜的外表下却隐藏着令人震惊的黑幕。',
      },
      {
        type: 'image',
        imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dirty%20kitchen%20interior%20with%20dramatic%20lighting%2C%20food%20safety%20violation%2C%20unhygienic%20conditions%2C%20moody%20investigative%20photography%2C%20warm%20amber%20glow%20on%20dark%20background&width=800&height=500&seq=article-img-011a&orientation=landscape',
        imageWidth: 800,
        imageHeight: 500,
        imageAlt: '后厨现场调查照片',
      },
      {
        type: 'heading',
        content: '触目惊心的后厨真相',
      },
      {
        type: 'paragraph',
        content: '经调查发现，该餐厅存在多项严重的食品安全问题：食材温度超标、使用过期原料、将顾客退回的菜品重新上桌、后厨员工无健康证上岗等。更令人震惊的是，部分标榜为"日本空运"的食材，实际来自本地一家无证经营的地下加工厂。',
      },
      {
        type: 'list',
        items: [
          '所谓"日本进口刺身级三文鱼"实际为国内养殖虹鳟鱼，售价翻了近10倍',
          '"A5和牛"使用普通国产牛肉假冒，通过特殊腌制手段伪装大理石花纹',
          '后厨冷冻库温度常年不达标，部分食材已严重变质',
          '多名后厨员工无健康证，甚至有员工带病上岗',
          '顾客退菜被重新摆盘后上给下一桌客人',
        ],
      },
      {
        type: 'heading',
        content: '灰色产业链揭秘',
      },
      {
        type: 'paragraph',
        content: '调查发现，该餐厅并非个例。在网红餐厅的火爆背后，存在着一条完整的灰色产业链：专业的"美化团队"负责包装餐厅形象，刷分团队负责在各大平台制造好评，而专业的"食材供应商"则提供低成本高利润的假冒食材。',
      },
      {
        type: 'paragraph',
        content: '业内人士透露，这条产业链已经相当成熟。"餐厅只需要做好营销和包装，其他的都有专门的团队来做。一道成本20元的菜，在网红餐厅可以卖到300元，这就是为什么那么多人挤破头也要开网红餐厅。"',
      },
      {
        type: 'quote',
        content: '"食客以为自己吃的是进口顶级食材，实际上吃的是国内最便宜的替代品。这不仅仅是欺诈，更是对消费者健康的严重威胁。"——食品安全专家评论',
      },
      {
        type: 'heading',
        content: '监管部门介入',
      },
      {
        type: 'paragraph',
        content: '事件曝光后，市场监管部门已对该餐厅进行突击检查，并责令其停业整顿。同时，相关部门表示将对网红餐饮行业开展专项整治行动，重点打击虚假宣传和食品安全违法行为。',
      },
      {
        type: 'paragraph',
        content: '吃瓜官网提醒广大消费者：选择餐厅时不要被精美的照片和好评所迷惑，食品安全永远是第一位的。如果发现餐厅存在问题，请及时向监管部门举报。',
      },
    ],
    relatedArticles: [
      {
        id: 'article-005',
        title: '深扒某MCN机构内幕：签约网红被严苛合同压榨，违约金高达千万',
        image: 'https://readdy.ai/api/search-image?query=Dark%20business%20contract%20with%20chain%20symbolism%2C%20dramatic%20lighting&width=400&height=300&seq=related-k-001&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-05',
        views: 1560000,
      },
      {
        id: 'article-007',
        title: '某上市公司CEO被爆私生活混乱，多名女性联合实名举报',
        image: 'https://readdy.ai/api/search-image?query=Corporate%20executive%20silhouette%20behind%20frosted%20glass%2C%20dramatic%20office%20lighting&width=400&height=300&seq=related-k-002&orientation=landscape',
        categoryName: '黑料专区',
        date: '2026-07-04',
        views: 1730000,
      },
      {
        id: 'article-003',
        title: '某知名带货主播涉嫌虚假宣传被立案调查，粉丝群炸锅了',
        image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20dark%20moody%20lighting&width=400&height=300&seq=related-k-003&orientation=landscape',
        categoryName: '热门爆料',
        date: '2026-07-06',
        views: 1890000,
      },
    ],
  },
};